module.exports = __webpack_public_path__ + "icon-150x150.png";